import React from 'react';

/** Prikazuje naziv pjesme – za duži tekst automatski skrol (marquee) */
export const ScrollingTrackText: React.FC<{
  text: string;
  className?: string;
}> = ({ text, className = '' }) => {
  const displayText = (text || '').trim();
  if (!displayText) return null;

  const needsScroll = displayText.length > 28;

  if (!needsScroll) {
    return (
      <span className={`truncate block ${className}`} title={displayText}>
        {displayText}
      </span>
    );
  }

  // Koristimo <span> umjesto <div> da je komponenta portable i unutar <p>
  // (validateDOMNesting: <div> ne smije unutar <p>). Ručno postavljamo display.
  return (
    <span
      className={`overflow-hidden w-full ${className}`}
      style={{ display: 'block' }}
      title={displayText}
    >
      <span className="animate-marquee-track">
        <span className="whitespace-nowrap">{displayText}</span>
        <span className="whitespace-nowrap">{' \u00A0—\u00A0 '}{displayText}</span>
      </span>
    </span>
  );
};
